/* eslint-disable no-debugger */
import useNewClubRegistrationStaff from './UseNewClubRegistrationStaff';

import ClubRegistrationConstants from '../utils/ClubRegistrationConstants';

import LeftNav from '@usas/ui-web/components/leftNav/LeftNav';
import Headings from '@usas/ui-web/components/headings/Headings';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';

import Constants from '@usas/ui-web/utils/Constants';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';

import NewClubRegistrationStaffGrid from './NewClubRegistrationStaffGrid';

const NewClubRegistrationStaff = () => {
    const {
        clubRegistrationNavState,
        clubRegistrationState,
        usasClubStaffState,
        requiredRolesFormattedState,
        orgLevelTypeHelpTextState,
        registrationRoles,
        onContinueClicked,
        onSaveAndExitClicked,
        onBackClicked,
        onEdit,
        onDelete
    } = useNewClubRegistrationStaff();

    return (
        <LeftNav title={ClubRegistrationConstants.LEFT_NAV_TITLE} state={clubRegistrationNavState} validateBeforeRedirect={false}>
            <div className="row">
                <div className="col-xs-12">
                    <Headings.H3>Club Staff</Headings.H3>
                </div>
            </div>
            <div className="row">
                <div className="col-xs-12 usas-extra-top-margin">
                <p dangerouslySetInnerHTML={{ __html: orgLevelTypeHelpTextState.objData.TypeText || ''}}></p>
                </div>
            </div>
            <NewClubRegistrationStaffGrid state={requiredRolesFormattedState} registrationRoles={registrationRoles} onEdit={onEdit} onDelete={onDelete} />
            <div className="row usas-extra-top-margin usas-extra-bottom-margin">
                <div className="col-xs-12">
                    <PrimaryButton type="button" onClick={() => onContinueClicked()}>Continue</PrimaryButton>&nbsp;
                    <PrimaryButton type="button" onClick={() => onSaveAndExitClicked()}>Save &amp; Exit</PrimaryButton>&nbsp;
                    <SecondaryButton type="button" onClick={() => onBackClicked()}>Back</SecondaryButton>
                </div>
            </div>
            <PopUpModal
                widthPct={50}
                maxWidth={250}
                title={Constants.LOADING_MSG}
                displayPopUp={ clubRegistrationState.isObjLoading || usasClubStaffState.isArrayLoading } />
        </LeftNav>
    );
}

export default NewClubRegistrationStaff;